'use client';

import { PropsWithChildren } from 'react';
import DraftSidebar from '../global/DraftSidebar';
import DraftHeader from '../global/DraftHeader';
import Shell from '../Shell';

type Props = PropsWithChildren;

export default function DraftShell({ children }: Props) {
  return (
    <Shell nav={<DraftHeader />} sidebar={<DraftSidebar />}>
      {children}
    </Shell>
  );
}
